import { singleFlightTokenRefresh } from 'pages/Auth/utils';
import { IRefreshAccessTokenResponse } from './types';

export const refreshAccessToken = async (): Promise<IRefreshAccessTokenResponse | null> => {
  const access = await singleFlightTokenRefresh();
  return access ? { access } : null;
};

export const memoizedRefreshToken = refreshAccessToken;
